import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Triage = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1429 7.99996H5.85715V8.97292C5.85715 8.98221 5.8456 8.98648 5.83955 8.97943L5.00558 8.00646C5.00237 8.00272 5.00237 7.99719 5.00558 7.99345L5.83955 7.02048C5.8456 7.01343 5.85715 7.0177 5.85715 7.02699V7.99996H10.1429V7.02699C10.1429 7.0177 10.1544 7.01343 10.1605 7.02048L10.9944 7.99345C10.9976 7.99719 10.9976 8.00272 10.9944 8.00646L10.1605 8.97943C10.1544 8.98648 10.1429 8.98221 10.1429 8.97292V7.99996Z"
        fill="currentColor"
      />
      <path
        d="M5.52051 6.63477C5.8391 6.36381 6.35742 6.58331 6.35742 7.02734V7.5H9.64258V7.02734C9.64259 6.55384 10.2319 6.33583 10.54 6.69531L11.374 7.66797C11.5378 7.85899 11.5377 8.14108 11.374 8.33203L10.54 9.30469C10.2319 9.66417 9.64258 9.44616 9.64258 8.97266V8.5H6.35742V8.97266C6.35742 9.44614 5.7681 9.66418 5.45996 9.30469L4.62598 8.33203C4.46227 8.14104 4.46227 7.85896 4.62598 7.66797L5.45996 6.69531L5.52051 6.63477Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75C10.6234 12.75 12.75 10.6234 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Triage;
